import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MortgageApplicationStore } from '@zhik/core/store/mortgage-journey/mortgage-application';

@Component({
  selector: 'dskhome-footer-links',
  templateUrl: './footer-links.component.html',
  styleUrls: ['./footer-links.component.scss'],
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterLinksComponent {
  private readonly mortgageApplicationStore = inject(MortgageApplicationStore);

  protected readonly isMortgageApplicationPath = this.mortgageApplicationStore.isMortgageApplicationPath;
}
